import React from 'react'

const TableDataField = ({children, extraStyling = ''}) => {
    let classes = "py-3 border-right border-dark";
    if(extraStyling) classes += ` ${extraStyling}`;
  return (
    <td className={classes} title={children}>
        {children}
    </td>
  )
}

export default TableDataField